<template>
    <div class="modal-container-cont">
        <div class="modal-container">
            <div class="modal-form-container">
                <div class="title-box">
                    <h2>Confirma Consumidor?</h2>
                </div>
            </div>

            <div class="form">
                <span>O pagamento virá de...</span>
                <span v-text="consumerData.consumerName" class="consumer-name"></span>
                <span>Deseja trocar por...</span>

                <div class="consumer-buttons">
                    <DefaultButton v-for="(consumer, key) in consumerData.consumersList" :key="key"
                        v-show="consumer.consumerCode !== consumerData.consumerCode"
                        :text="consumer.consumerName"
                        @defaultBtnClick="changeConsumer(consumer)">
                    </DefaultButton>
                </div>
            </div>

            <div class="prod-item-footer">
                <DefaultButton text="Não alterar" @defaultBtnClick="confirmConsumer()"></DefaultButton>
            </div>
        </div>
    </div>
</template>

<script>
// import Util from '@/assets/libs/util'
import DefaultButton from '@/components/DefaultButton'
// import CartController from '@/assets/controllers/CartController'
import IdentifiedConsumerController from '@/assets/controllers/IdentifiedConsumerController'
// import ProductController from '@/assets/controllers/ProductController'
// import requestModule from '@/assets/libs/requestModule'

export default {
    name: 'ConfirmConsumerModal',
    components: {
        DefaultButton
    },
    data () {
        return {
            consumerData: IdentifiedConsumerController.getConsumerData()
        }
    },
    props: [],
    methods: {
        confirmConsumer: function () {
            this.$emit('confirmConsumer')
        },
        changeConsumer: function (consumer) {
            this.$emit('changeConsumer', consumer)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>

    @import (reference) url("../assets/common.less");

    .modal-container-cont{
        .full;
        pointer-events: none;
        display: block;
        bottom: 0;
        z-index: 3;
    }

    .modal-container {
        position: absolute;
        pointer-events: auto;
        left: 0;
        right: 0;
        top: 50%;
        margin: auto 75px;
        background: @white;
        border-radius: 25px;
        box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
        transform: translate(0%, -50%);

        .modal-form-container {
            position: relative;
            overflow: hidden auto;

            .title-box {
                background-color: @primary-color;
                height: 120px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 25px 25px 0px 0px;

                h2 {
                    color: @white;
                    margin: auto;
                    font-size: 40px;
                }
            }
        }

        .form {
            margin: 0px 60px 0px 60px;
            min-height: 500px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            span {
                font-size: 35px;
                margin-bottom: 30px;
            }

            .consumer-name {
                font-size: 40px;
                color: @primary-color;
            }

            .consumer-buttons {
                margin-top: 30px;
            }

            .distance-bottom {
                margin-bottom: 45px;
            }
        }

        .balance-information {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 60px;

            .upper-div {
                margin-bottom: 15px
            }

            h2 {
                font-size: 40px;
                color: @primary-color;
                margin-bottom: 60px;
            }

            .balance-text {
                font-size: 30px;
            }

            .balance-value {
                font-size: 40px;
                color: @primary-color;
            }
        }

        .prod-item-footer {
            position: relative;
            display: flex;
            background: rgba(0, 0, 0, 0.1);
            height: 180px;
            border-radius: 0px 0px 25px 25px;

            button {
                position: relative;
                display: block;
                margin: auto;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/ConfirmConsumerModal.vue